module.exports = __webpack_public_path__ + "static/lifetime-warranty-2-092c693e2e3785f40843a600299353ac.png";